import { useAuth } from "@/lib/auth"
import { hasRole } from "@/lib/hasRole"
import { RoleType } from "@/types/User"

export const useRoleCheck = (roles: RoleType[] | RoleType) => {
  const { user, isLoading } = useAuth({
    middleware: 'auth',
    redirectTo: '/auth/login',
    tmp: 'useRoleCheck',
  })

  if (!user || isLoading) {
    return false
  }

  return hasRole(user.roles, roles)
}

export const useRoleGuard = (roles: RoleType[] | RoleType): { isAllowed: boolean, isLoading: boolean } => {
  const { user, isLoading } = useAuth({
    middleware: 'auth',
    redirectTo: '/auth/login',
    tmp: 'useRoleGuard',
  })

  if (!user || isLoading) {
    return { isAllowed: false, isLoading: true }
  }

  return { isAllowed: hasRole(user.roles, roles), isLoading: false }
}
